import getPathReduxUtil from 'modules/redux/utils/get-path'

/**
 * Get the number of `Notification`s unread.
 * @param  {Notifications[]} instances
 * @returns {number}
 */
function getUnreadCountNotificationsUtil (instances) {
  return instances.reduce((count, instance) => {
    if (!instance.data.read) {
      count += 1
    }
    return count
  }, 0)
}

/**
 * Gets the paths of the unread `Notification`s.
 * @param  {Notification[]} instances
 * @returns {String[]}
 */
function getUnreadPathsNotificationsUtil (instances) {
  return instances.reduce((storePaths, instance) => {
    if (!instance.data.read) {
      storePaths.push(
        getPathReduxUtil(instance)
      )
    }
    return storePaths
  }, [])
}

export {
  getUnreadCountNotificationsUtil,
  getUnreadPathsNotificationsUtil
}
